/* unplugin-vue-components disabled */import { render } from "./ai-suggestion.vue?vue&type=template&id=09a458b7&scoped=true"
import script from "./ai-suggestion.vue?vue&type=script&lang=js"
export * from "./ai-suggestion.vue?vue&type=script&lang=js"

import "./ai-suggestion.vue?vue&type=style&index=0&id=09a458b7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a458b7"],['__file',"src/components/ai-chat/ai-suggestion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09a458b7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09a458b7', __exports__)) {
    api.reload('09a458b7', __exports__)
  }
  
  module.hot.accept("./ai-suggestion.vue?vue&type=template&id=09a458b7&scoped=true", () => {
    api.rerender('09a458b7', render)
  })

}


export default __exports__